import DragHandleIcon from '@mui/icons-material/DragHandle';
import { Box } from '@mui/material';
import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { useTranslations } from '@/i18n/use-translations';
import { SLOT_LIST_DRAG_HANDLE_SIZE_PX } from './slot-list-layout';

type SlotListDragHandleProps = {
  isDragging: boolean;
  interactionDisabled: boolean;
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
};

export default function SlotListDragHandle({
  isDragging,
  interactionDisabled,
  attributes,
  listeners,
}: SlotListDragHandleProps) {
  const t = useTranslations();

  return (
    <Box
      component="button"
      type="button"
      aria-label={t('flows.detail.slotList.reorderDragHandleAria')}
      sx={{
        'flexShrink': 0,
        'display': 'inline-flex',
        'alignItems': 'center',
        'justifyContent': 'center',
        'width': SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        'minWidth': SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        'height': SLOT_LIST_DRAG_HANDLE_SIZE_PX,
        'p': 0,
        'm': 0,
        'border': 0,
        'borderRadius': 0.5,
        'bgcolor': 'transparent',
        'color': 'action.disabled',
        'cursor': interactionDisabled ? 'default' : isDragging ? 'grabbing' : 'grab',
        'pointerEvents': interactionDisabled ? 'none' : 'auto',
        'touchAction': 'none',
        'WebkitTapHighlightColor': 'transparent',
        '&:hover': { color: 'action.active', bgcolor: 'action.hover' },
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 1,
        },
      }}
      {...(interactionDisabled ? {} : attributes)}
      {...(interactionDisabled ? {} : listeners)}
      onClick={(e) => e.stopPropagation()}
    >
      <DragHandleIcon sx={{ fontSize: 16, transform: 'rotate(90deg)' }} />
    </Box>
  );
}
